import React, { Component } from "react";
import Accordion from "canvas-core-react/lib/Accordion";
import AccordionItem from "canvas-core-react/lib/AccordionItem";

class ProfileAccount extends Component {
  render() {
    return (
      <div className="accordionContent">
        <Accordion>
          <AccordionItem title="Datos de la cuenta 1">
            <div className="account-info clearfix">
              <div className="form-element">
                <p className="title">Tipo de cuenta</p>
                <p className="label">Internacional</p>
                <div className="line"></div>
              </div>

              <div className="form-element">
                <p className="title">IBAQN</p>
                <p className="label">S</p>
                <div className="line"></div>
              </div>

              <div className="form-element">
                <p className="title">Número de Cuenta</p>
                <p className="label">CR123456789012345678901</p>
                <div className="line"></div>
              </div>
              <div className="form-element">
                <p className="title">BIC Banco Destino</p>
                <p className="label">234758498383</p>
                <div className="line"></div>
              </div>
              <div className="form-element">
                <p className="title">Número de Cuenta Banco destino con intermediario</p>
                <p className="label">CR982873736454526727273</p>
                <div className="line"></div>
              </div>
              <div className="form-element">
                <p className="title">BIC Banco intermediario</p>
                <p className="label">9128384755565</p>
                <div className="line"></div>
              </div>
            </div>
          </AccordionItem>
          <AccordionItem title="Datos de la cuenta 2"><span>Datos insuficientes</span></AccordionItem>
          <AccordionItem title="Datos de la cuenta 3"><span>Datos insuficientes</span></AccordionItem>
        </Accordion>
      </div>
    );
  }
}

export default ProfileAccount;
